export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const SEARCH_PARAM = 'SEARCH_PARAM';

export default {
	DEFAULT_ASSIGN,
	SEARCH_PARAM
};
